import React from 'react';
import { PokemonList } from '../components/PokemonList/PokemonList';

export const HomeView = () => {
    return (
        <>
            <PokemonList />
        </>
    )
}
